<template>
  <el-dialog :title="title" :visible.sync="visiable" :close-on-click-modal="false" width="50%" @close="onClose()">
    <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="100px" class="messageTip">
      <!-- 只读 -->
      <div class="lx-flex-row">
        <el-form-item label="用户ID:">
          <span>{{ userName }}</span>
        </el-form-item>
        <el-form-item label="消息类型:">
          <span>{{ messageType }}</span>
        </el-form-item>
        <el-form-item v-if="orderNo" label="订单编号:">
          <span>{{ orderNo }}</span>
        </el-form-item>
      </div>
      <el-form-item label="模板:">
        <el-select v-model="replyInfo.remindingTitleJa" placeholder="请选择" @change="onChange">
          <el-option v-for="item in messageList" :key="item.id" :value="item.remindingTitle" :label="item.remindingTitle">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 内容 -->
      <el-form-item label="标题:" prop="remindingTitle">
        <el-input v-model="replyInfo.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item label="内容:" prop="remindingContent">
        <!-- <el-input v-model="replyInfo.remindingContent" type="textarea" :autosize='{minRows: 4}'></el-input> -->
        <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
      </el-form-item>
      <el-form-item label="跳转链接:" prop="url">
        <el-input v-model="replyInfo.url"></el-input>
      </el-form-item>
      <!-- 上传图片 -->
      <el-form-item label="图片:">
        <el-upload class="editor-slide-upload" action="https://zkvip-oss.oss-cn-hongkong.aliyuncs.com" :data="imgDataObj"
          :file-list="replyInfo.imgFileList" list-type="picture-card" :show-file-list="true" :on-remove="handleImgRemove"
          :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="9">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <!-- 上传附件 -->
      <el-form-item label="上传附件">
        <el-upload class="editor-slide-upload" action="" :on-preview="handlePreview" :on-remove="handleRemove"
          :before-upload="beforeUploadFile" :before-remove="beforeRemove" :on-success="handleOrderInfo" :show-file-list="true"
          :limit="1" :on-exceed="handleExceed" :file-list="fileList" :http-request="excelUploadRequest">
          <el-button class="search-btn btn-blue">上传附件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="text-align:right;">
      <el-button class="form-btn btn-gray" @click="onClose">取 消</el-button>
      <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Oss from "../../assets/js/oss.js";
const toolbarOptions = [
  ['bold'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
export default {
  name: "MessageTip",
  props: {
    title: {
      type: String,
      default: '提醒'
    },
    visiable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String || Number,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    }, // 用户id
    messageType: {
      type: String,
      default: '其他消息'
    }, // 消息类型
    orderId: {
      type: String || Number,
      default: ''
    }, // 订单id
    orderNo: {
      type: String || Number,
      default: ''
    }, // 订单编号
    httpUrl: {
      type: String,
      default: ''
    }, // 请求地址
  },
  data () {
    return {
      messageList: [],
      replyInfo: {
        id: '',
        orderId: '',
        orderNo: '',
        remindingUserName: '',
        remindingTitle: '',
        remindingTitleJa: '',
        remindingContent: '',
        url: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          }
        }
      },
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      rules: {
        remindingTitleJa: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },
      fileList: [],
      listObj: {},
    };
  },
  watch: {
    visiable (val) {
      if (val) {
        this.fileList = []
        this.replyInfo.fileName = ''
        this.replyInfo.filePath = ''
        this.doReset().then(() => {
          this.getMessageList()
        })
      }
    }
  },
  methods: {
    onChange (val) {
      const obj = this.messageList.find(item => item.remindingTitle === val)
      this.replyInfo.remindingTitle = obj.remindingTitleJa
      this.replyInfo.remindingContent = obj.remindingContentJa
      this.replyInfo.url = obj.url
    },
    getMessageList () {
      this.$http.get('template/message/getList').then(res => {
        this.messageList = res.data.data
      })
    },
    replySave (formName) {    //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },
    async addReply () {    //添加
      this.handleImgSubmit();
      this.replyInfo.orderId = this.orderId
      this.replyInfo.orderNo = this.orderNo
      this.replyInfo.remindingUserName = this.userName
      this.replyInfo.id = this.id
      console.log(this.replyInfo)
      const { data: res } = await this.$http.post(this.httpUrl, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.$emit('confirm')
      }
      else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      else {
        if (arr.length > 9) {
          _this.$message.error('最多可上传9张图片');
        }
        else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach(el => {
            urlArr.push(el.url);
          })
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.replyInfo.replyPictureList = _this.replyInfo.replyPicture.split(',')
          //   _this.$emit('successCBK', arr);
          _this.listObj = {};
          //   _this.imgDialogVisible = false;

        }
      }
    },
    handleImgRemove (file) {
      Oss.imgRemove(file, this.listObj);
      /*var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'block'
      })*/
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      /*var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'none'
      })*/
    },
    beforeImgUpload (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/order';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(true)
        })
      })
    },
    handlePreview () {
      // console.log(file);
    },
    handleRemove () {
      this.replyInfo.fileName = ''
      this.replyInfo.filePath = ''
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.'))
      // const size = file.size / 1024 / 1024
      if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf') {
        this.$message.warning('只能上传excel和pdf文件')
        return false
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    beforeRemove () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}?`);
    },
    // 批量导入成功回调
    handleOrderInfo () {
      console.log('success')
      // console.log(data)
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')},${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')},${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      );
    },
    // 批量导入
    async excelUploadRequest (file) {
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        this.replyInfo.fileName = res.data.fileName
        this.replyInfo.filePath = res.data.filePath
      }
    },
    onClose () {
      this.$emit('update:visiable', false)
    },
    doReset () {
      return new Promise(resolve => {
        this.replyInfo.remindingTitle = '',
          this.replyInfo.remindingTitleJa = '',
          this.replyInfo.remindingContent = '',
          this.replyInfo.url = '',
          this.replyInfo.replyPicture = '',
          this.replyInfo.imgFileList = [],
          this.replyInfo.imgFileListStr = ''
        this.fileList = []
        this.listObj = {}
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'block'
        })
        resolve()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.messageTip {
}
</style>
